export enum CountryCode {
  GB = "GB",
  IE = "IE",
}

export const CountryOptions = [
  {
    name: "United Kingdom",
    value: CountryCode.GB,
  },
  {
    name: "Ireland",
    value: CountryCode.IE,
  },
];
